<template>
  <section>
    <div class="row">
      <div class="col-12">
        <img src="/static/img/beneatForBussiness/a1.png" alt="" class="img-fluid w-100">
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <img src="/static/img/beneatForBussiness/a2.png"
             alt="" class="img-fluid w-100">
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <img src="/static/img/beneatForBussiness/a3.png" alt="" class="img-fluid  w-100">
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <img src="/static/img/beneatForBussiness/a4.png" alt="" class="img-fluid  w-100">
      </div>
    </div>
   
    <div class="row" style="margin-top: 100px;margin-bottom: 100px;">
      <div class="col-12 col-md-6 text-center">
        <a href="https://line.me/R/ti/p/%40hnk7011n">
          <img src="/static/img/beneatForBussiness/contact-line.png" alt="" class="img-fluid  w-100">
        </a>

        <h2 style="margin-top:50px;">หรือ โทร 02-113-1138</h2>

      </div>

      <div class="col-12 col-md-6 pl-md-5">

        <div class="card">
          <div class="card-body">
            <form @submit.prevent="sendEmail">
              <div class="form">
                <div class="form-group">
                  <label for="name">{{ $t('message.business.contact_name') }}*</label>
                  <input type="text"
                         class="form-control input-jumbo"
                         id="name"
                         ref="name"
                         v-model="contactData.name"
                         required>
                </div>
                <div class="form-group">
                  <label for="company_name">{{ $t('message.business.contact_company_name') }}*</label>
                  <input type="text"
                         class="form-control input-jumbo"
                         id="company_name"
                         ref="company_name"
                         v-model="contactData.company_name"
                         required>
                </div>
                <div class="form-group">
                  <label for="email">{{ $t('message.business.contact_email') }}*</label>
                  <input type="email"
                         class="form-control input-jumbo"
                         id="email"
                         ref="email"
                         v-model="contactData.email"
                         required>
                </div>
                <div class="form-group">
                  <label for="tel">{{ $t('message.business.contact_tel') }}*</label>
                  <input type="tel"
                         class="form-control input-jumbo"
                         id="tel"
                         ref="tel"
                         v-model="contactData.tel"
                         required>
                </div>
              </div>
              <button class="button button-large button-block -cyan"
                      type="submit"
              > {{ $t(isSending) }}
              </button>
            </form>
          </div>
        </div>

      </div>

    </div>

    <div class="row">
      <div class="col-12">
        <img src="/static/img/beneatForBussiness/a5.png" alt="" class="img-fluid  w-100">
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <img src="/static/img/beneatForBussiness/a6.png" alt="" class="img-fluid  w-100">
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <img src="/static/img/beneatForBussiness/a7.png" alt="" class="img-fluid  w-100">
      </div>
    </div>

    <div class="row" style="margin-top: 100px;margin-bottom: 100px;">
      <div class="col-12 col-md-6 text-center">
        <a href="https://line.me/R/ti/p/%40hnk7011n">
          <img src="/static/img/beneatForBussiness/contact-line.png" alt="" class="img-fluid  w-100">
        </a>

        <h2 style="margin-top:50px;">หรือ โทร 02-113-1138</h2>

      </div>

      <div class="col-12 col-md-6 pl-md-5">

        <div class="card">
          <div class="card-body">
            <form @submit.prevent="sendEmail">
              <div class="form">
                <div class="form-group">
                  <label for="name1">{{ $t('message.business.contact_name') }}*</label>
                  <input type="text"
                         class="form-control input-jumbo"
                         id="name1"
                         ref="name"
                         v-model="contactData.name"
                         required>
                </div>
                <div class="form-group">
                  <label for="company_name1">{{ $t('message.business.contact_company_name') }}*</label>
                  <input type="text"
                         class="form-control input-jumbo"
                         id="company_name1"
                         ref="company_name"
                         v-model="contactData.company_name"
                         required>
                </div>
                <div class="form-group">
                  <label for="email1">{{ $t('message.business.contact_email') }}*</label>
                  <input type="email"
                         class="form-control input-jumbo"
                         id="email1"
                         ref="email"
                         v-model="contactData.email"
                         required>
                </div>
                <div class="form-group">
                  <label for="tel1">{{ $t('message.business.contact_tel') }}*</label>
                  <input type="tel"
                         class="form-control input-jumbo"
                         id="tel1"
                         ref="tel"
                         v-model="contactData.tel"
                         required>
                </div>
              </div>
              <button class="button button-large button-block -cyan"
              type="submit"
              > {{ $t(isSending) }}
              </button>
            </form>

          </div>
        </div>

      </div>

    </div>

    <section>
        <section-partner />
        <div class="row">
          <div class="col-md-6 pr-3 pl-3">
            <div class="embed-responsive embed-responsive-16by9 mt-4">
              <iframe width="560"
                      height="315"
                      src="https://www.youtube.com/embed/RTbcjC9Udzg"
                      frameborder="0"
                      allow="autoplay; encrypted-media"
                      allowfullscreen></iframe>
            </div>
          </div>
          <div class="col-md-6 pr-3 pl-3">
            <div class="embed-responsive embed-responsive-16by9 mt-4">
              <iframe width="560"
                      height="315"
                      src="https://www.youtube.com/embed/xCGWH7JU83M"
                      frameborder="0"
                      allow="autoplay; encrypted-media"
                      allowfullscreen></iframe>
            </div>
          </div>
        </div>
    </section>


    <div class="row" style="margin-top: 100px;margin-bottom: 100px;">
      <div class="col-12 text-center">
        <h2 class="text-center">Download Application</h2>
        <hr style="border-top: 2px solid #24d4e7">
        <div class="plat-form-icon">
          <a href="https://itunes.apple.com/th/app/beneat/id1203611695?mt=8">
            <img src="/static/img/btn-app-store.svg" alt="">
          </a>
          <a href="https://play.google.com/store/apps/details?id=com.beneat.app">
            <img src="/static/img/btn-play-store.svg" alt="">
          </a>
        </div>

      </div>
    </div>

  </section>
</template>

<script>
  import { mapGetters } from 'vuex'
  import SectionPartner from '../SectionPartner.vue'
  export default {
    name: 'index',
    components: {
      SectionPartner
    },
    data () {
      return {
        contactData: {
          from: 'Business Page',
          name: '',
          company_name: '',
          email: '',
          tel: ''
        }
      }
    },
    computed: {
      ...mapGetters({
        isSendingEmail: 'business/getIsSendingEmail',
        isSending: 'business/isSending'
      })
    },
    watch: {
      isSendingEmail () {
        if (!this.isSendingEmail) {
          this.contactData = {
            name: '',
            company_name: '',
            email: '',
            tel: ''
          }
          this.$swal({
            type: 'success',
            title: this.$i18n.t('message.business.thank_you'),
            text: this.$i18n.t('message.business.contact_you_soon')
          })
        }
      }
    },
    methods: {
      validation () {
        let result = true
        const emailFormat = new RegExp('^([a-z0-9\\+_\\-]+)(\\.[a-z0-9\\+_\\-]+)*@([a-z0-9\\-]+\\.)+[a-z]{2,6}$')
        if (this.contactData.name === '') {
          this.$refs.name.focus()
          result = false
        } else if (this.contactData.company_name === '') {
          this.$refs.company_name.focus()
          result = false
        } else if (this.contactData.email === '') {
          this.$refs.email.focus()
          result = false
        } else if (this.contactData.email && !emailFormat.test(this.contactData.email)) {
          this.contactData.email = ''
          this.$refs.email.focus()
          result = false
        } else if (this.contactData.tel === '') {
          this.$refs.tel.focus()
          result = false
        } else {
          result = true
        }
        return result
      },
      sendEmail () {
        if (this.validation()) {
          this.$store.dispatch('business/SEND_EMAIL', this.contactData)
        }
      }
    }
  }
</script>

<style scoped>
  [class*="col-"] {
    padding: 0;
  }

  div.plat-form-icon img{
    margin: 5px 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/information/BeneatForBussiness.vue